export { InputText } from "./InputText";
